module.exports = __webpack_public_path__ + "img/credit-card-secure-3.87f5f684.png";